import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import { loadRuntimeConfig } from './app/config/runtimeConfig';

const bootstrap = async () => {
  await loadRuntimeConfig();

  const { AppRouter } = await import('./router/approuter');
  const { default: reportWebVitals } = await import('./reportWebVitals');

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};

bootstrap();
